
export default {
  mounted() {
    window.au5ton.translateWidget(
      {
        pageLanguage: 'en',
        chunkSize: 3,
        endpoints: {
          supportedLanguages: 'https://translate.1800victims.org/languages',
          translate: 'https://translate.1800victims.org/translate',
        },
      },
      'libre-widget'
    )
  },
}
